import { render, staticRenderFns } from "./SelectService.vue?vue&type=template&id=329f0224&scoped=true&"
import script from "./SelectService.vue?vue&type=script&lang=js&"
export * from "./SelectService.vue?vue&type=script&lang=js&"
import style0 from "./SelectService.vue?vue&type=style&index=0&id=329f0224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f0224",
  null
  
)

export default component.exports